import { createAction, props } from '@ngrx/store';
import { IApproveFICAUpdateRequest, IApproveFICAUpdateResponse } from '../models/approve-fica.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

// Updating approve fica
export const loadApproveFICARequest = createAction(
  '[ApproveFICA] Load approve fica request',
  props<{ request: IApproveFICAUpdateRequest }>()
);

export const loadApproveFICAResponse = createAction(
  '[ApproveFICA] Load approve fica Success',
  props<{ response: IApproveFICAUpdateResponse }>()
);

export const loadApproveFICAFailure = createAction(
  '[ApproveFICA] Load approve fica Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
